<template>
  <div class="app-container">
    <div class="filter-container">
      <el-input style="width: 400px" class="filter-item" placeholder="输入手机号或ID" v-model="listQuery.keyword" clearable></el-input>
      <el-button class="filter-item" type="primary" icon="el-icon-search" @click="handleFilter">搜索</el-button>
    </div>
    <el-table :data="list" v-loading.body="listLoading" element-loading-text="加载中 ..." border highlight-current-row>
      <el-table-column type="index" align="center" label="序号" width="90"></el-table-column>
      <el-table-column label="用户ID" width="240" align="center" prop="unionuuid"></el-table-column>
      <el-table-column label="用户手机号" width="150" align="center" prop="mobile"></el-table-column>
      <el-table-column label="昵称" width="150" align="center" prop="nickname" show-overflow-tooltip></el-table-column>
      <el-table-column label="学习阶段" width="150" align="center" prop="grade"></el-table-column>
      <el-table-column label="考研年份" width="150" align="center" prop="pubmed_year"></el-table-column>
      <el-table-column label="注册时间" width="180" align="center" prop="add_time"></el-table-column>
      <el-table-column label="用户状态" width="150" align="center">
        <template slot-scope="{ row }">
          <el-tag :type="row.is_logoff ? 'warning' : ''">
            {{ row.is_logoff ? '已注销' : '正常' }}
          </el-tag>
        </template>
      </el-table-column>
      <el-table-column label="用户身份" width="120" align="center">
        <template slot-scope="{ row }">
          {{ row.user_type === 'student' ? '学生' : '家长' }}
        </template>
      </el-table-column>
      <el-table-column label="操作" min-width="150px">
        <template slot-scope="{ row }">
          <el-button type="primary" size="mini" @click="$refs.detail.handleDetail(row.uuid)">查看详情</el-button>
          <el-button type="danger" size="mini" @click="$refs.resetPasswordRef.show(row.uuid)" v-permission="['account.change_password']" v-if="!row.is_logoff">重置密码</el-button>
        </template>
      </el-table-column>
    </el-table>

    <div class="pagination-container">
      <pagination :total="count" :page.sync="listQuery.page" :limit.sync="listQuery.size" @pagination="fetchData" />
    </div>

    <detail ref="detail"></detail>
    <ResetPassword ref="resetPasswordRef" @refresh="fetchData" />
  </div>
</template>

<script>
import { getList } from '@/api/user'
import Detail from './components/Detail'
import ResetPassword from './components/ResetPassword'

export default {
  name: 'userIndex',
  data() {
    return {
      list: null,
      count: 0,
      listLoading: false,
      listQuery: {
        page: 1,
        size: 10,
        keyword: '',
      },
    }
  },
  components: {
    Detail,
    ResetPassword,
  },
  methods: {
    // 获取数据
    fetchData() {
      this.listLoading = true
      getList(this.listQuery).then((res) => {
        this.list = res.data.results
        this.count = res.data.count
        this.listLoading = false
      })
    },
    // 筛选
    handleFilter() {
      this.listQuery.page = 1
      this.fetchData()
    },
  },
}
</script>
